export default "__VITE_ASSET__CIHVzvLi__"